export default "__VITE_ASSET__DAru8_gH__"